import { render } from "./ProjectCardReprintStamp.vue?vue&type=template&id=08cfda68"
import script from "./ProjectCardReprintStamp.vue?vue&type=script&lang=js"
export * from "./ProjectCardReprintStamp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__